import React, { memo } from 'react';
import { FadeIn } from './FadeIn';
import { Check } from 'lucide-react';
export function PricingCards() {
  return <section className="py-3 px-3 max-w-2xl mx-auto pt-[0px] pb-[0px] space-y-[0px] mt-[20px] mb-[20px]" id="pricing" data-id="element-220">
      <FadeIn data-id="element-221">
        <h2 className="text-lg md:text-xl font-black text-center mb-3" data-id="element-222">
          ELEGÍ TU COMBO
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-xl mx-auto" data-id="element-223">
        {/* Card 1 */}
        <FadeIn delay={0.1} data-id="element-224">
          <div className="bg-gray-900 border border-gray-800 rounded-xl p-3 h-full flex flex-col relative" data-id="element-225">
            <div className="mb-2" data-id="element-226">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-227">
                <span data-id="element-228">📘</span> MEGAPACK PSICOLOGÍA LISTA
              </h3>
              <p className="text-gray-400 font-medium text-xs" data-id="element-229">
                6 Tomos + 6 Bonos
              </p>
            </div>

            <div className="mb-2" data-id="element-230">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-231">
                $35.400
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-232">
                $19.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-233">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-234">
              <li className="flex items-start gap-1.5" data-id="element-235">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-236" />
                <span className="text-gray-300 text-xs" data-id="element-237">
                  Acceso a los 6 Tomos completos
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-238">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-239" />
                <span className="text-gray-300 text-xs" data-id="element-240">
                  Los 6 Bonos de regalo
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-241">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-242" />
                <span className="text-gray-300 text-xs" data-id="element-243">
                  Actualizaciones de por vida
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44079714402340:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-gray-800 hover:bg-gray-700 text-white transition-colors border border-gray-700" data-id="element-244">
              → QUIERO MI MEGAPACK
            </a>
          </div>
        </FadeIn>

        {/* Card 2 - Featured */}
        <FadeIn delay={0.2} data-id="element-245">
          <div className="bg-gradient-to-b from-gray-900 to-black border-2 border-sky-500 rounded-xl p-3 h-full flex flex-col relative transform md:-translate-y-1 shadow-[0_0_15px_rgba(14,165,233,0.15)]" data-id="element-246">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-sky-500 text-black font-bold px-2.5 py-0.5 rounded-full text-[10px] flex items-center gap-1 whitespace-nowrap" data-id="element-247">
              ⭐ MÁS ELEGIDO
            </div>

            <div className="mb-2 mt-1.5" data-id="element-248">
              <h3 className="text-sm font-bold text-white flex items-center gap-1.5 mb-0.5" data-id="element-249">
                <span data-id="element-250">🏆</span> MEGAPACK + CRITERIO PROFESIONAL
              </h3>
              <p className="text-sky-400 font-medium text-xs" data-id="element-251">
                6 Tomos + 6 Bonos + Upsell Premium
              </p>
              <p className="text-gray-400 text-[10px] mt-1 leading-tight" data-id="element-252">
                Para estudiantes que quieren pasar de memorizar a pensar como
                psicólogos
              </p>
            </div>

            <div className="mb-2" data-id="element-253">
              <div className="text-red-400 line-through text-sm font-medium" data-id="element-254">
                $47.300
              </div>
              <div className="text-xl font-black text-white flex items-baseline gap-1" data-id="element-255">
                $27.990{' '}
                <span className="text-xs text-gray-400 font-medium" data-id="element-256">ARS</span>
              </div>
            </div>

            <ul className="space-y-1.5 mb-3 flex-grow" data-id="element-257">
              <li className="flex items-start gap-1.5" data-id="element-258">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-259" />
                <span className="text-gray-200 font-medium text-xs" data-id="element-260">
                  Todo lo del Megapack Básico
                </span>
              </li>
              <li className="flex items-start gap-1.5 bg-sky-900/20 p-1 rounded-md -mx-1" data-id="element-261">
                <Check className="text-sky-400 shrink-0 mt-0.5" size={12} data-id="element-262" />
                <span className="text-sky-100 font-bold text-xs" data-id="element-263">
                  Criterio Profesional
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-264">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-265" />
                <span className="text-gray-300 text-xs" data-id="element-266">
                  Diccionario de 30 verbos
                </span>
              </li>
              <li className="flex items-start gap-1.5" data-id="element-267">
                <Check className="text-sky-500 shrink-0 mt-0.5" size={12} data-id="element-268" />
                <span className="text-gray-300 text-xs" data-id="element-269">
                  5 casos reales resueltos
                </span>
              </li>
            </ul>

            <a href="https://tumanualdigital.com/cart/44079723675684:1" className="w-full block text-center py-1.5 px-3 rounded-md font-bold text-sm bg-sky-500 hover:bg-sky-400 text-black transition-all hover:scale-[1.02] shadow-lg" data-id="element-270">
              → QUIERO EL COMBO COMPLETO
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}